module.exports = __webpack_public_path__ + "static/media/yumin-01.a3738f78.svg";